import React, { Component } from 'react';
import Service from '../service/Service';
const service = new Service();
import * as actions from './actions';
let myData = {};
let flag = false;
var items = [];
var _myData = '';
import { fetchInitialData } from "../fetchData";
class FinderAmp extends Component {
    constructor(props) {
        super(props)
        let categoryList = [];
        this.alphabetsAry = [];
        for (let i = 0; i < 26; i++) {
            this.alphabetsAry.push((i + 10).toString(36));
        }
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            if (window.__initialData__['initialData']) {
                categoryList = window.__initialData__['initialData']['categoryList'];
            }
            
            delete window.__initialData__;
        } else {
            
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                categoryList = props.staticContext.initialData['initialData']['categoryList'];
            }
        }
        
        var SearchKey = '';
        if(props.location.search.includes("?norecordfound=")){
            SearchKey = props.location.search.split("?norecordfound=")[1];
        } else {
            SearchKey = "";
        }
        this.state = {
            SearchKey : SearchKey,
            categoryList:categoryList,
            metaTitle: "Baby Names List: Find 100000+ Baby Names for Boys & Girls",
            metaDescription: [
                { "name": "description", "content": "Find the latest, most popular and unique baby names for your newborn from a list of 100000+ Baby Boy & Girl Names ideas with FirstCry’s Baby Names Finder." },
                { "name": "keywords", "content": "baby names, unique baby names, popular baby names" },
                {  "name" : "robots", "content" : "all" }
            ]
        };
        this.disPageNo = 1;
        if (this.props.match.params.page && this.props.match.params.page > 0) {
            this.disPageNo = parseInt(this.props.match.params.page);
        }
        this.maxScroll = 0;

    }

    static initialAction(reqUrl, ftk, authData, uId, childData, cookieData){
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        
        if(reqUrl.includes("/?norecordfound=")){
            var keyword = reqUrl.split("/?norecordfound=")[1];
        } else {
            var keyword = "";
        }
        // console.log(keyword);
        var url = global.api_url + "getbabysearchbyfilters";
        var body = JSON.stringify({
            "gender": "all",
            "religion": "all",
            "category": "",
            "keyword" : keyword,
            "startwith" : "all",
            "origin" : "all",
            "numerology" : "all",
            "rashi" : "all",
            "nakshatra" : "all",
            "god" : "all",
            "pageNo": 1,
            "pageSize" : 100,
            "sortkey" : "Most Popular"
        });

        return fetchInitialData(url, JSON.stringify(header), body);
    }
    noSearch() {
        var items = [];
        
        this.state.categoryList.map((value, index) => {
            var gendername = value.cat_filter[0].key;
            var religionname = value.cat_filter[1].key;
            var catName = value.category_name;
            var originName = value.cat_filter[2].key;

            if((gendername.length > 1)){
                var gen = gendername[0] +  ", " + gendername[1] +  ", " +gendername[2];
            } else {
                var gen = gendername;
            }
            if(religionname != ""){
               var _param = religionname;
            } else {
                var _param = originName;
            }

            items.push(
                <li key={index}>
                    <a href={actions.toListingPage(`${catName}`, `${gen}`, `${_param}`,` `, this)} target="_self">
                        <span className="R14_42 category_title">{catName}</span>
                        <span className="R14_9e icon right" data-icon-font="l"></span>
                    </a>
                </li>);
            }
        )
        return (
            items
        )
    }
   
    render() {
        var _myData = '';

        if(this.state.categoryList){
            _myData = this.noSearch();
        }

        return (
            <main className="baby-names-main main-container">
                <div className="data-container">
                
                <meta name="atdlayout" content="babynames_ap" />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a className="R11_9e" href={service.getRedirectUrl("/")}>Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a className="R11_9e" href={service.getRedirectUrl("/baby-names")}>Baby Names</a></span>
                    </div>
                    <h1 className="B24_00"> Baby Names Finder</h1>
                </div>
                <div className="sub-container">
                    <div className="search_result_container">
                        <div className="finder_block">
                            <div className="search_container" style={{overflow: 'visible'}}>
                                <div className="search_header">
                                    <span className="desksearch_input">
                                        <a href={service.getRedirectUrl(`/baby-names/amp/`)} className="backToLanding">
                                            <span className="icon backarrow left" data-icon-font="s"></span>
                                        </a>
                                        <form className="sample-form" method="post" name="searchname" action-xhr={`${global.hosturl}parenting/BabynamesAmp/searchName`} encType="application/json" custom-validation-reporting="show-first-on-submit">
                                            <div className="search_here">
                                                <span className="icon search_icon" data-icon-font="'"></span>
                                                <input type="text" id="myInputdesk" name="searchkey" placeholder="Search" defaultValue={this.state.SearchKey} onChange="" autoFocus required/>
                                                
                                                <input type="hidden" name="currentUrl" defaultValue={global.currentURL} />
                                                
                                                <button className="searchbtn right" type="submit" tabIndex="0" role="button" on={`tap: AMP.setState({SearchKey : ''})`} id="dev_se_rch">Search</button>
                                                
                                                <span visible-when-invalid="valueMissing" validation-for="myInputdesk"></span>
                                            </div>
                                            <input type="reset" value="Reset" id="reset"/>
                                            <label htmlFor="reset" className="icon closeicon right" data-icon-font="C"></label>
                                        </form>
                                    </span>
                                </div>
                            </div>
                        </div>
                        {
                            this.state.categoryList ?
                            <div className="no_record_page" id="no_record_page" >
                                <div className="R15_9e term_not_found"></div>
                                <div className="R15_9e try_another_name">No result found for term "{this.state.SearchKey}"</div>
                                <div className="R15_9e try_another_name">Try searching for other term</div>
                                <div className="M14_42 browse_names">Browse our popular Categories</div>
                                <ul className="">
                                    {_myData}
                                </ul>
                            </div> :
                            ''
                        }
                    </div>
                </div>
                </div>
            </main>
        )
    }
}

export default FinderAmp



// WEBPACK FOOTER //
// src/shared/baby-names-amp/FinderAmp.js